import React from 'react';
import { BookOpenIcon, LayersIcon, PaletteIcon, ScissorsIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { SectionHeading } from './ui/SectionHeading';
import { modulos } from '../data/landing';
const iconos = [ScissorsIcon, PaletteIcon, LayersIcon, BookOpenIcon];
export function Metodo() {
  return <section id="metodo" className="w-full bg-arena py-12 sm:py-20" aria-labelledby="metodo-titulo" data-id="element-108" data-mp="21y9favjzclqh">
      <div className="mx-auto max-w-5xl px-5 sm:px-8" data-id="element-109" data-mp="2gmmc1uqw68m1">
        <Reveal data-id="element-110" data-mp="2bp4d8x6l99rr">
          <SectionHeading eyebrow="Qué incluye" title={<span id="metodo-titulo" data-id="element-112" data-mp="2bokx9m0i0vgd">Un método completo, paso a paso</span>} data-id="element-111" data-mp="2bpnk9iupadr0" />
        </Reveal>

        <div className="mt-8 grid gap-4 sm:mt-12 sm:gap-6 lg:grid-cols-2" data-id="element-113" data-mp="2pnubig559fhp">
          {modulos.map((modulo, index) => {
          const Icono = iconos[index];
          return <Reveal key={modulo.titulo} delay={0.05 * index} data-id="element-114" data-mp="v9t436vj3k60" data-mpi={index}>
                <article className="flex h-full gap-4 rounded-3xl border border-rosa-100 bg-white p-5 shadow-tarjeta sm:p-7" data-id="element-115" data-mp="qbj6kpmc07h8">
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-rosa-50 text-frambuesa" data-id="element-116" data-mp="38vav02zi3fpl">
                    <Icono className="h-6 w-6" aria-hidden="true" data-id="element-117" data-mp="3du48vwip98qa" />
                  </span>
                  <div data-id="element-118" data-mp="3irxfgqnx04r3">
                    <span className="font-sans text-[11px] font-bold uppercase tracking-[0.18em] text-terracota" data-id="element-119" data-mp="3iqmainiqgqye">
                      {modulo.etiqueta}
                    </span>
                    <h3 className="mt-1 font-serif text-xl leading-snug text-borgona sm:text-2xl" data-id="element-120" data-mp="3rkhg1wnrojek">
                      {modulo.titulo}
                    </h3>
                    <p className="mt-2 font-sans text-base leading-relaxed text-suave" data-id="element-121" data-mp="5d9ihgj39gt3">
                      {modulo.descripcion}
                    </p>
                  </div>
                </article>
              </Reveal>;
        })}
        </div>
      </div>
    </section>;
}